// Per-page & per-language SEO keywords for GEM PRICE.
// Google no longer reads <meta keywords> for ranking, but Bing/Yandex/DuckDuckGo
// still do — and having a coherent list also helps you audit content coverage.

const COMMON_FR = [
  "pierres précieuses",
  "prix pierres précieuses",
  "tarifs pierres précieuses",
  "cours pierres précieuses",
  "prix au carat",
  "gemmologie",
  "gemme",
  "saphir",
  "rubis",
  "émeraude",
  "prix saphir",
  "prix rubis",
  "prix émeraude",
  "saphir par carat",
  "rubis par carat",
  "émeraude par carat",
  "estimation pierre précieuse",
  "valeur pierre précieuse",
  "cotation gemme",
  "expertise gemmologique",
  "certificat gemmologique",
  "origine pierre précieuse",
  "saphir de Ceylan",
  "rubis de Birmanie",
  "émeraude de Colombie",
  "saphir du Cachemire",
  "saphir Padparadscha",
  "saphir change de couleur",
  "saphir étoilé",
  "rubis étoilé",
  "émeraude trapiche",
  "GIA",
  "IGI",
  "Gübelin",
  "SSEF",
  "AGL",
  "GRS Gemsearch",
  "Lotus Gemology",
  "Tucson Gem & Mineral Show",
  "AGTA GemFair Tucson",
  "salon Sainte-Marie-aux-Mines",
  "bijouterie de luxe",
  "joaillerie",
  "gemmologue",
  "abonnement gemmologie",
  "GEM PRICE",
];

const COMMON_EN = [
  "gemstones",
  "gemstone prices",
  "precious stone prices",
  "gem market prices",
  "per carat price",
  "gemology",
  "gemstone",
  "sapphire",
  "ruby",
  "emerald",
  "sapphire price",
  "ruby price",
  "emerald price",
  "sapphire per carat",
  "ruby per carat",
  "emerald per carat",
  "gemstone valuation",
  "gemstone value",
  "gem quotation",
  "gemological expertise",
  "gemological certificate",
  "gemstone origin",
  "Ceylon sapphire",
  "Burmese ruby",
  "Colombian emerald",
  "Kashmir sapphire",
  "Padparadscha sapphire",
  "colour-change sapphire",
  "color-change sapphire",
  "star sapphire",
  "star ruby",
  "trapiche emerald",
  "GIA",
  "IGI",
  "Gübelin",
  "SSEF",
  "AGL",
  "GRS Gemsearch",
  "Lotus Gemology",
  "Tucson Gem & Mineral Show",
  "AGTA GemFair Tucson",
  "Sainte-Marie-aux-Mines show",
  "luxury jewelry",
  "fine jewelry",
  "gemologist",
  "gemstone subscription",
  "GEM PRICE",
];

const PAGE_FR = {
  "/": [
    "GEM PRICE",
    "référence prix pierres précieuses",
    "abonnement pierres précieuses",
    "tarification saphir rubis émeraude",
    "prix carat par origine",
  ],
  "/labs": [
    "laboratoires gemmologiques",
    "certification pierre précieuse",
    "adresse GIA",
    "adresse IGI",
    "adresse Gübelin",
    "adresse SSEF",
    "expertise indépendante",
  ],
  "/formation": [
    "formation pierres précieuses",
    "géologie gemmes",
    "formation saphir",
    "formation rubis",
    "formation émeraude",
    "gisement pierre précieuse",
  ],
  "/treatments": [
    "traitement pierre précieuse",
    "saphir chauffé",
    "rubis chauffé",
    "émeraude huilée",
    "traitement diffusion",
    "irradiation gemme",
    "impact traitement valeur",
  ],
  "/synthetics": [
    "pierre synthétique",
    "saphir synthétique",
    "rubis synthétique",
    "émeraude synthétique",
    "procédé Verneuil",
    "hydrothermale",
    "fusion de zone",
    "identifier pierre synthétique",
  ],
  "/journal": [
    "actualité gemmologie",
    "salon pierres précieuses",
    "événement gemmologie",
    "nouvelles mines",
    "recherche gemmologique",
    "tendances marché pierres précieuses",
  ],
  "/privacy": ["politique confidentialité", "RGPD", "protection données"],
  "/terms": ["conditions générales", "CGV abonnement", "mentions légales"],
};

const PAGE_EN = {
  "/": [
    "GEM PRICE",
    "gemstone price reference",
    "gemstone subscription",
    "sapphire ruby emerald pricing",
    "per carat price by origin",
  ],
  "/labs": [
    "gemological laboratories",
    "gemstone certification",
    "GIA address",
    "IGI address",
    "Gübelin address",
    "SSEF address",
    "independent expertise",
  ],
  "/formation": [
    "gemstone formation",
    "gem geology",
    "sapphire formation",
    "ruby formation",
    "emerald formation",
    "gem deposit",
  ],
  "/treatments": [
    "gemstone treatment",
    "heated sapphire",
    "heated ruby",
    "oiled emerald",
    "diffusion treatment",
    "gem irradiation",
    "treatment impact on value",
  ],
  "/synthetics": [
    "synthetic gemstone",
    "synthetic sapphire",
    "synthetic ruby",
    "synthetic emerald",
    "Verneuil process",
    "hydrothermal",
    "floating zone",
    "identify synthetic gem",
  ],
  "/journal": [
    "gemology news",
    "gem show",
    "gemology event",
    "new mines",
    "gemological research",
    "gemstone market trends",
  ],
  "/privacy": ["privacy policy", "GDPR", "data protection"],
  "/terms": ["terms and conditions", "subscription terms", "legal notice"],
};

export const getKeywords = (lang, path = "/") => {
  const common = lang === "fr" ? COMMON_FR : COMMON_EN;
  const page = (lang === "fr" ? PAGE_FR : PAGE_EN)[path] || [];
  // Dedup while preserving order (page-specific first for early relevance).
  return Array.from(new Set([...page, ...common])).join(", ");
};

export default getKeywords;
